export default __webpack_public_path__ + "static/media/bg_payment_page_mobile.d262d21e.png";